// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + ".chunk." + {354: "8ac5c04d04569170",441: "f555a32df114cfd8",519: "8035c4b3d69be49c",520: "e7fbcd23c895f54d",}[chunkId] + ".css"
}